<div class="body">
  <div class="container mt-4">
    @if (editar) {
      <div class="title-box">
        <h3 class="txtbienvenida">Editar <span class="txtbienvenida-2">suspensión</span></h3>
      </div>
    }
    @if (!editar) {
      <div class="title-box">
        <h3 class="txtbienvenida">Crear nueva <span class="txtbienvenida-2">suspensión</span></h3>
      </div>
    }
    <div class="container mt-4">
      <form [formGroup]="administrarFechasyHorasForm" (ngSubmit)="idSuspensionServicio ? editarDatosHorarios() : guardarDatosHorarios()">

        <div class="row">
          <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xs-6">
            <div class="mb-3 form-label">
              <label for="fechaInicial" class="form-label">Fecha inicial de la suspensión del servicio*</label>
              <input type="date" min="{{fechaActual}}" class="form-control" formControlName="fechaInicial">
              @if (validateField('', 'fechaInicial')) {
                <div class="form-text">
                  Este campo es obligatorio
                </div>
              }
            </div>
          </div>

          <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xs-6">
            <div class="mb-3 form-label">
              <label for="fechaFinal" class="form-label">Fecha final de la suspensión del servicio*</label>
              <input type="date" min="{{fechaActual}}" class="form-control" formControlName="fechaFinal">
              @if (validateField('', 'fechaFinal')) {
                <div class="form-text">
                  Este campo es obligatorio
                </div>
              }
            </div>
          </div>

          <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xs-6">
            <div class="mb-3 form-label">
              <label for="horaInicial" class="form-label">Hora inicial de la suspensión del servicio*</label>
              <input type="time" class="form-control" formControlName="horaInicial">
              @if (validateField('', 'horaInicial')) {
                <div class="form-text">
                  Este campo es obligatorio
                </div>
              }
            </div>
          </div>

          <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xs-6">
            <div class="mb-3 form-label">
              <label for="horaFinal" class="form-label">Hora final de la suspensión del servicio*</label>
              <input type="time" class="form-control" formControlName="horaFinal">
              @if (validateField('', 'horaFinal')) {
                <div class="form-text">
                  Este campo es obligatorio
                </div>
              }
            </div>
          </div>

          <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xs-12">
            <div class="mb-3 required form-label">
              <label for="justificacion" class="form-label">Justificación</label>
              <textarea rows="4" class="form-control" maxlength="500" formControlName="justificacion" required>
              </textarea>
              @if (validateField('', 'justificacion')) {
                <div class="form-text">
                  Este campo es obligatorio
                </div>
              }
            </div>
          </div>
        </div>
        <div class="row mt-5 justify-content-md-center g-3">
          @if (!idSuspensionServicio) {
            <div class="col-12 col-md-2 container-btn">
              <button type="submit" [disabled]="!administrarFechasyHorasForm.valid" style="width: 180px;" class="btn btn-primary hvr-shrink">
                Registrar
              </button>
            </div>
          }
          @if (idSuspensionServicio) {
            <div class="col-12 col-md-2 container-btn">
              <button type="submit" [disabled]="!administrarFechasyHorasForm.valid" style="width: 180px;" class="btn btn-primary hvr-shrink">
                Modificar
              </button>
            </div>
          }
          <div class="col-12 col-md-2 container-btn">
            <button class="btn  btn-primary hvr-shrink" style="width: 180px;" [routerLink]="['/intermediario/administracion/administracionFechayHora']">
              Volver
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
  <div class="footer-body"></div>
  <!-- Modal -->
  <div class="modal fade text-center" style="color: black;" id="crearModal" tabindex="-1" aria-labelledby="crearModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-body justify-content-md-center">
          <div class="row">
            <div class="col-12 col-sm-12 me-3 ms-3" style="color: black;">
              <h2>La creación de la suspensión fue realizada con éxito</h2>
            </div>
          </div>
        </div>
        <div class="modal-footer justify-content-md-center">
          <button type="button" class="btn btn-primary" (click)="aceptar()">Aceptar</button>
        </div>
      </div>
    </div>
  </div>
  <div class="modal fade text-center" style="color: black;" id="modificarModal" tabindex="-1" aria-labelledby="aceptarModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-body justify-content-md-center">
          <div class="row">
            <div class="col-12 col-sm-12 me-3 ms-3" style="color: black;">
              <h2>La modificación de la suspensión fue realizada con éxito</h2>
            </div>
          </div>
        </div>
        <div class="modal-footer justify-content-md-center">
          <button type="button" class="btn btn-primary" (click)="aceptar()">Aceptar</button>
        </div>
      </div>
    </div>
  </div>
</div>